module.exports = __webpack_public_path__ + "assets/img/Fotolia_102685773_XS.a510ffdb.jpg";